import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBB = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M35.87 2.48A24.9 24.9 0 0 0 25 0a24.9 24.9 0 0 0-10.87 2.48L11.956 25l2.174 22.52A24.9 24.9 0 0 0 25 50a24.9 24.9 0 0 0 10.87-2.48L38.042 25 35.87 2.48Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M14.13 2.481C5.768 6.525 0 15.088 0 25c0 9.911 5.768 18.474 14.13 22.518V2.481ZM35.87 2.481v45.037C44.232 43.474 50 34.911 50 25c0-9.912-5.768-18.475-14.13-22.519Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "m32.608 15.216 1.459.73-1.459-.73-1.458-.729c-.088.176-1.992 4.05-2.303 9.968H26.63v-9.239L25 13.042l-1.63 2.174v9.24h-2.217c-.311-5.919-2.215-9.793-2.303-9.969l-2.917 1.458c.02.04 2.002 4.074 2.002 10.14v1.631h5.434v9.24h3.261v-9.24h5.435v-1.63c0-3.137.543-5.723.998-7.34.496-1.764 1-2.794 1.006-2.804l-1.46-.726Z"
}));
FlagBB.displayName = 'FlagBB';
export default withFlagWrapper(FlagBB);
//# sourceMappingURL=index.js.map